export default {
  load_error_title: "Échec du chargement du document",
  load_error_subtitle:
    "Désolé, le document n'a pas pu être chargé. Veuillez réessayer ultérieurement.",
};
